import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '@/auth/useAuth';
import type { Role } from '@/constants/roles';
import { ROUTES } from '@/constants/routes';

export interface RoleRouteProps {
  roles: readonly Role[];
}

/**
 * Route-level role gating: redirects to `/403` rather than hiding content inline. Mount inside
 * `ProtectedRoute` — this assumes the user is already authenticated and only checks role membership.
 */
export function RoleRoute({ roles }: RoleRouteProps) {
  const { hasAnyRole } = useAuth();

  if (!hasAnyRole(roles)) {
    return <Navigate to={ROUTES.forbidden} replace />;
  }

  return <Outlet />;
}
